function TransactionReportsService($http, AppSettings, Upload) {
  'ngInject';

  const service = {};
  
  function basePath(orgId) {
    return AppSettings.apiUrl + '/organizations/' + orgId + '/transaction_reports';
  }

  // Get all runs for an organization
  service.getRuns = function (orgId, params) {
    return $http.get(basePath(orgId) + '/runs', { params: params });
  };

  // Get a single run
  service.getRun = function (orgId, runId) {
    return $http.get(basePath(orgId) + '/runs/' + runId);
  };

  // Upload a transaction report CSV
  service.upload = function (orgId, file, marketplace, callback) {
    Upload.upload({
      url: basePath(orgId) + '/upload',
      data: { file: file, marketplace: marketplace || 'amazon.com' }
    }).then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  // Get mapping/settings for an organization
  service.getMapping = function (orgId, marketplace) {
    return $http.get(basePath(orgId) + '/settings', {
      params: { marketplace: marketplace || 'amazon.com' }
    });
  };

  // Save mapping/settings
  service.saveMapping = function (orgId, mapping) {
    return $http.put(basePath(orgId) + '/settings', mapping);
  };

  // Post to Xero
  service.postToXero = function (orgId, runId) {
    return $http.post(basePath(orgId) + '/runs/' + runId + '/post');
  };

  // Delete a run
  service.deleteRun = function (orgId, runId) {
    return $http.delete(basePath(orgId) + '/runs/' + runId);
  };

  // Retry/refresh a run
  service.retryRun = function (orgId, runId) {
    return $http.post(basePath(orgId) + '/runs/' + runId + '/retry');
  };

  // Get Xero accounts for mapping
  service.getAccounts = function (orgId) {
    return $http.get(basePath(orgId) + '/accounts');
  };

  return service;
}

TransactionReportsService.$inject = ['$http', 'AppSettings', 'Upload'];

export default {
  name: 'TransactionReportsService',
  fn: TransactionReportsService
};
